function TenantManagedDevicesCtrl($scope, $stateParams, TenantsService, DevicesService, ProgressBarService, $state) {
  "ngInject";

  let vm = this;
  vm.currentTenant = {
    key: undefined,
    name: undefined,
    code: undefined,
    adminEmail: undefined,
    contentServerUrl: undefined,
    contentManagerBaseUrl: undefined,
    domainId: undefined,
    notificationEmails: undefined,
    proofOfPlayLogging: false,
    active: true
  };
  vm.tenantDevices = [];
  vm.devicesPrev = null;
  vm.devicesNext = null;
  vm.selectedButton = "Serial Number";
  vm.serialDevices = {};
  vm.idDevices = {};
  vm.disabled = true;
  vm.devicesToMatchOn = [];
  vm.macDevices = {};
  vm.editMode = !!$stateParams.tenantId;
  vm.tenantId = $stateParams.tenantId;

  vm.getManagedDevices = function (tenantId, page) {
    ProgressBarService.start();
    let devicesPromise = DevicesService.getDevicesByTenant(tenantId, page);
    devicesPromise.then(function (data) {
      vm.devicesPrev = data["previous"];
      vm.devicesNext = data["next"];
      vm.tenantDevices = data["devices"];
      vm.devicesCount = data["count"];
      ProgressBarService.complete();
    });
  };

  vm.editItem = (item) => DevicesService.editItem(item)

  vm.refreshDevices = function () {
    vm.devicesPrev = null;
    vm.devicesNext = null;
    vm.tenantDevices = null;
    vm.getManagedDevices(vm.tenantId, vm.devicesPrev, vm.devicesNext);
  };

  if (vm.editMode) {
    let tenantPromise = TenantsService.getTenantById(vm.tenantId);
    tenantPromise.then(tenant => vm.currentTenant = tenant);
    vm.getManagedDevices(vm.tenantId);
  }

  $scope.tabIndex = 1;

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  vm.changeRadio = function () {
    vm.searchText = '';
    vm.disabled = true;
    vm.serialDevices = {};
    vm.macDevices = {};
    vm.idDevices = {};
    vm.devicesToMatchOn = [];
  };

  vm.searchDevices = function (partial) {
    let unmanaged = false;
    let button = vm.selectedButton;
    let byTenant = true;
    let tenantId = vm.tenantId;
    return DevicesService.searchDevices(partial, button, byTenant, tenantId, vm.managingOrgId, unmanaged)
      .then(function (response) {
        let devicesToReturn;
        if (response.success) {
          let devices = response.devices
          if (button === "Serial Number") {
            vm.serialDevices = devices[1]
            devicesToReturn = devices[0]
          } else if (button === "Device Key") {
            vm.idDevices = devices[1]
            devicesToReturn = devices[0]
          } else if (button === "MAC") {
            vm.macDevices = devices[1]
            devicesToReturn = devices[0]
          } else {
            vm.gcmidDevices = devices[1]
            devicesToReturn = devices[0]
          }
          vm.devicesToMatchOn = devicesToReturn
          return devicesToReturn
        } else {
          return []
        }
      })
  };

  vm.prepareForEditView = (searchText) => DevicesService.prepareForEditView(
    vm.selectedButton,
    vm.tenantId,
    searchText,
    vm.macDevices,
    vm.serialDevices,
    vm.idDevices,
    vm.gcmidDevices
  );

  vm.controlOpenButton = function (isMatch) {
    vm.disabled = !isMatch;
    vm.loadingDisabled = false;
  };

  vm.isResourceValid = function (resource) {
    let foundMatch = false;
    for (let item of vm.devicesToMatchOn) {
      if (resource === item) {
        foundMatch = true;
      }
    }
    vm.controlOpenButton(foundMatch)
    return foundMatch
  };

  return vm;
}

export {TenantManagedDevicesCtrl}
